export enum ERoleExtraIsBuyer {
	Buyer = 'Buyer',
	NotBuyer = 'NotBuyer',
}

export const ROLE_EXTRA_IS_BUYER_LABEL_MAP: Record<ERoleExtraIsBuyer, string> = {
	[ERoleExtraIsBuyer.Buyer]: `role_extra_is_buyer.${ERoleExtraIsBuyer.Buyer}`,
	[ERoleExtraIsBuyer.NotBuyer]: `role_extra_is_buyer.${ERoleExtraIsBuyer.NotBuyer}`
}